import React from 'react'
import Icon from 'UI/FontAwesomeIcon'

const useColumns = ({ onUpdate, onRemove }) => {
  const monitoringTypeColumn = {
    Header: 'Monitoring Type',
    accessor: 'monitoringType'
  }

  const connectionTypeColumn = {
    Header: 'Connection Type',
    accessor: 'connectionType'
  }

  const collectorTypeColumn = {
    Header: 'Collector Type',
    accessor: 'collectorType'
  }

  const actionsColumn = {
    Header: 'Actions',
    width: 80,
    Cell: row => (
      <div className="flex items-center justify-center">
        <Icon
          className="text-xl text-gray-400 mr-2 duration-300 cursor-pointer hover:text-blue-600"
          icon="edit"
          onClick={() => onUpdate(row.original)}
          title="Edit"
        />

        <Icon
          className="text-xl text-gray-400 duration-300 cursor-pointer hover:text-red-600"
          icon="trash"
          onClick={() => onRemove(row.original)}
          title="Delete"
        />
      </div>
    )
  }

  return [
    monitoringTypeColumn,
    connectionTypeColumn,
    collectorTypeColumn,
    actionsColumn
  ]
}


export default useColumns

